import React from 'react';
import GrayTag from './_base/GrayTag';

export default function OfferTag(props) {
  return (
    <GrayTag label="OFFER" />
  );
}
